import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PreCheckoutLoginComponent } from './pages/pre-checkout-login/pre-checkout-login.component';
import { NoaccessComponent } from './pages/noaccess/noaccess.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { PreCheckoutComponent } from './pages/pre-checkout/pre-checkout.component';
import { PreCheckoutViagemComponent } from './pages/pre-checkout-viagem/pre-checkout-viagem.component';
import { PreCheckoutVeiculoComponent } from './pages/pre-checkout-veiculo/pre-checkout-veiculo.component';
import { PreCheckoutAprovadoComponent } from './pages/pre-checkout-aprovado/pre-checkout-aprovado.component';

const routes: Routes = [
  {path: 'start', component: PreCheckoutComponent},
  {path: 'login', component: PreCheckoutLoginComponent, canActivate: [AuthGuard]},
  {path: 'viagem', component: PreCheckoutViagemComponent, canActivate: [AuthGuard]},
  {path: 'veiculo', component: PreCheckoutVeiculoComponent, canActivate: [AuthGuard]},
  {path: 'aprovado', component: PreCheckoutAprovadoComponent, canActivate: [AuthGuard]},
  {path: 'noaccess', component: NoaccessComponent},
  {path: '**', component: NotfoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
